module.exports = __webpack_public_path__ + "static/media/filsauskate.56248543.png";